// 🔹 commonHelpers.js

// Normalize course (single source of truth)
export const normalizeCourse = (course = "") => {
  const clean = course
    .replace(/nursing/i, "")
    .replace(/\./g, "")
    .trim()
    .toUpperCase();

  if (clean.includes("BSC")) return "BSC";
  if (clean.includes("GNM")) return "GNM";

  return clean;
};

// Extract student parts
export const extractStudentParts = (studentId = "") => {
  const [studentNo = "", year = ""] = studentId.split("/");
  return { studentNo, year };
};

// Get duration years
export const getCourseYears = (course) => {
  const c = normalizeCourse(course);

  if (c === "BSC") return 4;
  if (c === "GNM") return 3;

  return 0;
};